(() => {
  if (window.stwrapRotateOctoberPromo) return;
  let next = 0;
  try { next = Number(sessionStorage.getItem('stwrap-october-promo-next')) === 1 ? 1 : 0; } catch {}
  const originals = new WeakMap();
  window.stwrapRotateOctoberPromo = (scope) => {
    const cards = [...scope.querySelectorAll('[data-stwrap-october-promo]')].filter(card => card.querySelector('template[data-stwrap-october-alternate]'));
    if (!cards.length) return;
    cards.forEach(card => {
      const current = card.querySelector(':scope > a');
      if (!current) return;
      if (!originals.has(card)) originals.set(card, current.cloneNode(true));
      const alternate = card.querySelector('template[data-stwrap-october-alternate]').content.querySelector('a');
      current.replaceWith((next === 1 ? alternate : originals.get(card)).cloneNode(true));
    });
    next = 1 - next;
    try { sessionStorage.setItem('stwrap-october-promo-next', String(next)); } catch {}
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.y-menu--level-1--link > button[aria-controls]');
    if (!trigger) return;
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (panel) window.stwrapRotateOctoberPromo(panel);
  }, true);
})();
